"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookItemConverterImpl_1 = require("../../core/model/codebook/conversions/CodebookItemConverterImpl");

var PlacementTypes_1 = require("../model/PlacementTypes");

var PlacementTypesConverter_1 = require("./PlacementTypesConverter");
/**
 * Default implementation of PromotionTypeConverter.
 *
 * @author ZSr
 */


var PlacementTypesConverterImpl =
/*#__PURE__*/
function (_PlacementTypesConver) {
  _inherits(PlacementTypesConverterImpl, _PlacementTypesConver);

  function PlacementTypesConverterImpl() {
    var _this;

    _classCallCheck(this, PlacementTypesConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlacementTypesConverterImpl).call(this));
    _this.codebookItemConverter = new CodebookItemConverterImpl_1.CodebookItemConverterImpl();
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PlacementTypesConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var codebookItem = this.codebookItemConverter.toObject(source, conversions);
      return new PlacementTypes_1.PlacementTypes(PlacementTypes_1.PlacementTypes.schema.id.valueOf(conversions.documentToClassId(source)), PlacementTypes_1.PlacementTypes.schema.title.valueOfField(source), PlacementTypes_1.PlacementTypes.schema.externalId.valueOfField(source));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var document = {};
      Object.assign(document, this.codebookItemConverter.toDocument(source, conversions));
      Object.assign(document, {
        id: source.id,
        title: source.title,
        externalId: source.externalId
      });
      return document;
    }
  }]);

  return PlacementTypesConverterImpl;
}(PlacementTypesConverter_1.PlacementTypesConverter);

exports.PlacementTypesConverterImpl = PlacementTypesConverterImpl;